@if (!url && !iconOnly) {
	<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
}


@if (media) {

	@switch (media._type) {

		@case ('image') {
			@if (!media._displayableImage || iconOnly) {
				@if (showTitle) {
					<a href="{{url}}" title="{{media.med_titre}}">
						<media-icon [tym_code]="media.tym_code" class="mr-2"></media-icon>
						@if (showTitle) {
							<span>{{media.med_titre}}</span>
						}
					</a>
				}
				@if (!showTitle) {
					<media-icon [tym_code]="media.tym_code" class=""></media-icon>
				}
			}

			@if (media._displayableImage && !iconOnly) {
				<img
					[src]="url"
					(click)="onImgClicked(media.med_id)"
					[title]="media.med_titre"
					width="auto"
					height="auto"
					loading="lazy"
				>
			}
		}

		@case ('lien') {
			<a href="{{media.med_url}}" title="{{media.med_titre}}" target="_blank">
				<media-icon [tym_code]="media.tym_code" class="mr-2"></media-icon>
				@if (showTitle) {
					<span>{{media.med_titre}}</span>
				}
			</a>
		}

		@case ('pdf') {
			@if (showPdf) {
				<embed [src]="url" class="pdf-viewer" type="application/pdf">
			}
		}

		@case ('video') {
			@if (media._embedded_video) {
				<div [injectHTML]="media._embedded_video"></div>
			}
			@if (!media._embedded_video) {
				<video muted class="" controls [src]="url"></video>
			}
		}


		@default {
			<a [href]="url" title="{{media.med_titre}}" target="_blank">
				<media-icon [tym_code]="media.tym_code" class="mr-2"></media-icon>
				@if (showTitle) {
					<span>{{media.med_titre}}</span>
				}
			</a>
		}

	}

}
<!--<div>{{media|json}}</div>-->
